import { Helmet } from 'react-helmet-async';

const DEFAULT = {
  title: 'Plumly — Le Tinder des livres',
  description: 'Découvre des livres en swipant, lis des histoires captivantes, publie tes propres œuvres et rejoins une communauté de passionnés de lecture.',
  image: 'https://plumly.fr/og-image.png',
  url: 'https://plumly.fr',
};

export default function SEO({ title, description, image, url, type = 'website' }) {
  const seoTitle = title ? `${title} — Plumly` : DEFAULT.title;
  const seoDesc = description || DEFAULT.description;
  const seoImage = image || DEFAULT.image;
  const seoUrl = url || DEFAULT.url;

  return (
    <Helmet>
      <title>{seoTitle}</title>
      <meta name="description" content={seoDesc} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDesc} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:url" content={seoUrl} />
      <meta property="og:site_name" content="Plumly" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDesc} />
      <meta name="twitter:image" content={seoImage} />

      <link rel="canonical" href={seoUrl} />
    </Helmet>
  );
}